<template>
  <vs-table v-if="show" :params="params" :options="options"></vs-table>
</template>

<script>
  import VsTable from "../_framework/VsTable.vue";

  export default {
    name: "outsource",
    created: () => {
    },
    beforeMount() {
      this.options.access = checkAccess(this.$route.path);
      //console.log(this.options.access);
      this.show = this.options.access ? true : false;
    },
    components: {
      VsTable
    },
    data() {
      return {
        show: true,
        access: {},
        options: {
          autoLoad: true,
          // clickableRows: false,
          hasActions: true,
          fetchParams: {
            pageIndex: 0,
            pageSize: 20
          },
          hasActionsInHeader: true,
          clickableRows: true,
          onRowClicked: row => {
            this.$emit("selectOutsource", row);
          },
          onRowDoubleClicked: row => {
            this.$emit("onRowDoubleClicked", row);
          },
          beforeDeleteEntity: input => {
            this.refreshTable();
            return input;
          },
          beforeCreateEntity: input => {
            this.refreshTable();
            return input;
          },
          beforeUpdateEntity: input => {
            this.refreshTable();
            return input;
          },
          // onCreateHeaderActionClicked: () => {
          //   console.log("fdfdsf");
          // },
          getTopRightButtons: () => {
            let arr = [];

            let searchToggleButton = {
              component: "search-toggle-button"
            };
            arr.push(searchToggleButton);

            return arr;
          },
          getTopLeftButtons: () => {
            let arr = [];

            let self = this;

            let addItemButton = {
              component: "toggle-table-actions-button",
              params: {
                onClick() {
                  self.options.hasActions = !self.options.hasActions;
                }
              }
            };
            arr.push(addItemButton);

            return arr;
          }
        },
        params: {
          entity: "outsource",
          headers: {
            outSourceName: {
              title: "عنوان شرکت",
              type: "text"
            }
          }
        }
      };
    },
    methods: {
      refreshTable() {
        /* this.show = false;
         setTimeout(() => {
           this.show = true;
         }, 100);*/
      }
    }
  };
</script>
